import * as ActionTypes from '../ActionTypes'

export const setAdobeCepExtentions = extentions => ({
  type: ActionTypes.SET_ADOBE_CEP_EXTENTIONS,
  payload: {
    extentions,
  },
})

export const openCepExtension = extension => ({
  type: ActionTypes.OPEN_CEP_EXTENSION,
  payload: {
    extension,
  },
})

export const closeCepExtension = extensionId => ({
  type: ActionTypes.CLOSE_CEP_EXTENSION,
  payload: {
    extensionId,
  },
})
